import { SignalMedium, WifiOff } from 'lucide-react';
import { FLOW, useConnectionHealth, useShownBars } from '../state/health';

/** With no call bar on screen to turn yellow or red, a card of its own says the connection weakened or dropped. */
export function ConnectionNotice() {
  const health = useConnectionHealth();
  const bars = useShownBars((s) => s.count);
  if (health.level === 'good' || bars > 0) return null;
  return (
    <div role="status" aria-label="Bağlantı" className={`${FLOW[health.level]} flex min-h-11 flex-none items-center gap-3 px-3 py-1.5 text-white md:px-5`}>
      {health.level === 'poor' ? <WifiOff size={18} aria-hidden="true" /> : <SignalMedium size={18} aria-hidden="true" />}
      <span className="min-w-0 flex-1 truncate text-[13.5px] font-bold">{health.text}</span>
    </div>
  );
}
